<micro-lookup domain="pay" obj="paymentCarriers" url="/pay/paymentCarriers" [key]="paymentCarrierId"></micro-lookup>
